import { FC } from 'react';

import { InnerTabRequest } from 'contexts/TabContext';
import { TabRecordType, TabSection } from 'constants/tabs';
import ServicesPage from 'pages/ServicesPage';
import ServiceDetailPage from 'pages/ServiceDetailPage';
import JobsPage from 'pages/JobsPage';
import JobDetailPage from 'pages/JobDetailPage';
import ClientPage from 'pages/ClientPage';
import ClientDetailPage from 'pages/ClientDetailPage';
import InvoicePage from 'pages/InvoicePage';
import InvoiceDetailPage from 'pages/InvoiceDetailPage';
import SchedulePage from 'pages/SchedulePage';

export interface RecordPageProps {
  /** Optional because each page also renders straight from a route, where it reads the match. */
  recordId?: string;
  /**
   * Section within the page that the link asked for. Only pages with sections of their own read it;
   * it travels as a prop rather than in location.state because location.state is shared by every
   * open tab, so one client tab moving would drag the others with it.
   */
  innerTab?: InnerTabRequest;
}

/**
 * Which page renders which tab.
 *
 * One place, shared by TabHost and by the routes that mount it, so a module can never be half wired
 * up — listed in one map and forgotten in the other.
 */
export const SECTION_PAGE: Partial<Record<TabSection, FC>> = {
  [TabSection.QUOTATIONS]: ServicesPage,
  [TabSection.JOBS]: JobsPage,
  [TabSection.CLIENTS]: ClientPage,
  [TabSection.INVOICES]: InvoicePage,
  [TabSection.SCHEDULE]: SchedulePage
};

export const RECORD_PAGE: Partial<Record<TabRecordType, FC<RecordPageProps>>> = {
  [TabRecordType.QUOTATION]: ServiceDetailPage,
  [TabRecordType.JOB]: JobDetailPage,
  [TabRecordType.CLIENT]: ClientDetailPage,
  [TabRecordType.INVOICE]: InvoiceDetailPage
};
